<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>DATE SHEET</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Date sheet</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section>
    <div class="container">
        <h2 class="text-center text-primary">Date Sheet</h2>
        <table class="table table-responsive table-bordered" id="gvdatesheet">
            <thead style="background-color: #e67e22;color: white;">
            <tr>
                <th class="bg-secondary text-center text-white" style="width:60%">DateSheet</th>
                <th class="bg-secondary text-center text-white" style="width: 10%">Download</th>
            </tr>
            </thead>
            <tbody style="background: aliceblue;color:#e67e22; font-weight: bold;">
            <tr>
                <td> FINAL EXTERNAL EXAM DATE SHEET END-SEMESTER EXAMINATIONS (Regular) - Jan- 2023</td>
                <td><a href="https://arni.in/Datesheet/Datesheet.pdf" target="_blank">Download</a></td>
            </tr>
            </tbody>
        </table>
    </div>
</section>
